import React, { useEffect, useState } from "react";
import {
    getCustomerGiftcard,
    transactionredeem,
} from "@/services/customer";

import {
    ArrowLeft,
    Gift,
    Home,
    Loader2,
} from "lucide-react";

import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import response from "./response.json"
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomerData } from "@/redux/slices/customerSlice";

export const Giftcard = () => {
    const dispatch = useDispatch()
    const [loader, setLoader] = useState(true);
    const [giftcards, setGiftcards] = useState([]);
    const [selectedCard, setSelectedCard] = useState(null);
    const [selectedAmount, setSelectedAmount] = useState(null);
    const [redeemLoading, setRedeemLoading] = useState(false);
    const { data: customer, loading } = useSelector((state) => state.customer);

    const navigate = useNavigate();
    const availablePoints = customer?.walletsDetail?.availableValue || 0

    useEffect(() => {
        const customerCode = localStorage.getItem("customercode");
        if (!customer) dispatch(fetchCustomerData(customerCode));
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            try {
                // const res = await getCustomerGiftcard();

                setGiftcards(response?.data || []);
            } catch (error) {
                console.error(error);
            } finally {
                setLoader(false);
            }
        };

        fetchData();
    }, []);

    const handleRedeemGiftcard = async () => {
        if (!selectedCard || !selectedAmount) return;
        if (Number(selectedAmount) > availablePoints) {
            toast.error("Insufficient wallet balance");
            return;
        }
        try {
            setRedeemLoading(true);

            const token_gen = JSON.parse(
                localStorage.getItem("token_gen")
            );

            const customerCode =
                localStorage.getItem("customercode");

            const now = new Date().toISOString();

            const body = {
                customer: {
                    customercode: customerCode,
                },
                redeemDetail: {
                    walletType: "point",
                    values: Number(selectedAmount),
                    transactionType: "redeem",
                    transactionDate: now,
                },
            };

            const response = await transactionredeem(
                token_gen?.access_token,
                body
            );

            console.log(response);

            if (
                response?.message !==
                "Request processed successfully."
            ) {
                toast.error(response?.message || "Redeem failed");
                return;
            }

            toast.success(
                `${selectedCard.title} redeemed successfully for ₹${selectedAmount}`
            );

            setSelectedCard(null);
            setSelectedAmount(null);

        } catch (error) {
            console.error(error);
            toast.error("Something went wrong");
        } finally {
            setRedeemLoading(false);
        }
    };

    return (
        <div
            className="min-h-screen flex flex-col items-center"
            style={{
                fontFamily: "'Poppins', sans-serif",
                backgroundColor: "#fff5f5",
                backgroundImage:
                    "radial-gradient(circle, #ffd6d6 1px, transparent 1px)",
                backgroundSize: "22px 22px",
            }}
        >
            <div className="w-full max-w-md min-h-screen flex flex-col bg-[#ffe5e5]">

                {/* HEADER */}
                <div className="relative flex items-center justify-center px-4 py-4 mt-2">
                    <button
                        onClick={() => navigate(-1)}
                        className="absolute left-4 w-9 h-9 flex items-center justify-center rounded-full bg-white shadow-md border border-[#ffd6d6]"
                    >
                        <ArrowLeft className="w-5 h-5 text-[#111111]" />
                    </button>

                    <p className="text-[15px] font-semibold text-[#111111]">
                        Gift Cards
                    </p>

                    <button
                        onClick={() => navigate("/home")}
                        className="absolute right-4 w-9 h-9 flex items-center justify-center rounded-full bg-white shadow-md border border-[#ffd6d6]"
                    >
                        <Home className="w-5 h-5 text-[#111111]" />
                    </button>
                </div>

                {/* CONTENT */}
                <div className="px-4 pb-8 flex-1">

                    {loader ? (
                        <div className="fixed inset-0 bg-black/20 flex justify-center items-center z-50 backdrop-blur-sm">
                            <Loader2 className="animate-spin h-10 w-10 text-[#F40009]" />
                        </div>
                    ) : giftcards.length === 0 ? (
                        <div className="bg-white rounded-2xl shadow-md border border-[#ffd6d6] py-14 px-6 text-center">

                            <div className="w-16 h-16 mx-auto rounded-full bg-[#fff0f0] flex items-center justify-center mb-4">
                                <Gift className="w-8 h-8 text-[#F40009]" />
                            </div>

                            <h2 className="text-[16px] font-bold text-[#111111] mb-2">
                                No Gift Cards Found
                            </h2>

                            <p className="text-[13px] text-gray-500">
                                Your redeemed gift cards will appear here.
                            </p>
                        </div>
                    ) : (
                        <div className="space-y-4">

                            {giftcards.map((card, index) => (
                                <div
                                    key={index}
                                    onClick={() => {
                                        setSelectedCard(card);
                                        setSelectedAmount(null);
                                    }}
                                    className="bg-white rounded-3xl overflow-hidden shadow-md border border-[#ffd6d6] cursor-pointer active:scale-[0.98] transition-transform"
                                >

                                    {/* IMAGE */}
                                    <div className="relative h-[180px] bg-[#fff5f5]">
                                        <img
                                            src={card.image}
                                            alt={card.title}
                                            className="w-full h-full object-cover"
                                        />

                                        <div className="absolute top-3 left-3 px-3 py-1 rounded-full bg-[#F40009]/80 backdrop-blur-sm">
                                            <p className="text-[10px] font-semibold text-white uppercase tracking-wider">
                                                {card.category}
                                            </p>
                                        </div>
                                    </div>

                                    {/* CONTENT */}
                                    <div className="p-4">

                                        <div className="flex items-start justify-between gap-3">

                                            <div>
                                                <h2 className="text-[18px] font-bold text-[#111111]">
                                                    {card.title}
                                                </h2>

                                                <p className="text-[12px] text-gray-500 mt-1">
                                                    {card.giftcard_type}
                                                </p>
                                            </div>

                                            <div className="w-11 h-11 rounded-full bg-[#ffe5e5] flex items-center justify-center shrink-0">
                                                <Gift className="w-5 h-5 text-[#F40009]" />
                                            </div>

                                        </div>

                                        {/* DESCRIPTION */}
                                        <div className="mt-3">
                                            <div
                                                className="text-[12px] text-gray-500 leading-relaxed line-clamp-3"
                                                dangerouslySetInnerHTML={{
                                                    __html: card.description,
                                                }}
                                            />

                                            <div
                                                className="text-[#F40009] text-[12px] font-semibold mt-2 hover:text-[#B30000]"
                                            >
                                                Read More
                                            </div>
                                        </div>

                                        {/* DENOMINATIONS */}
                                        <div className="flex flex-wrap gap-2 mt-4">
                                            {card.denominations?.map((item, idx) => (
                                                <div
                                                    key={idx}
                                                    className="px-3 py-2 rounded-xl bg-[#fff0f0] border border-[#ffd6d6]"
                                                >
                                                    <p className="text-[13px] font-semibold text-[#F40009]">
                                                        ₹{item.fix_value}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>

                                    </div>
                                </div>
                            ))}

                        </div>
                    )}
                </div>

                {/* FOOTER */}
                {/* <div className="w-full py-3 border-t border-[#ffd6d6] mt-auto">
                    <p className="text-[13px] text-black uppercase text-center tracking-wide">
                        © {new Date().getFullYear()} Consumer Journeys. All Rights Reserved.
                    </p>
                </div> */}

                {/* MODAL */}
                {selectedCard && (
                    <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-end justify-center">

                        <div className="bg-white w-full max-w-md rounded-t-[28px] p-5 max-h-[90vh] overflow-y-auto border border-[#ffd6d6]">

                            {/* HEADER */}
                            <div className="flex items-start justify-between gap-3 mb-4">

                                <div>
                                    <p className="text-[11px] uppercase tracking-wider text-[#F40009] font-semibold">
                                        {selectedCard.category}
                                    </p>

                                    <h2 className="text-[22px] font-bold text-[#111111] mt-1">
                                        {selectedCard.title}
                                    </h2>

                                    {/* <p className="text-[13px] text-[#F40009] font-semibold mt-1">
                                        Available Balance: ₹{availablePoints}
                                    </p> */}
                                </div>

                                <button
                                    onClick={() => {
                                        setSelectedCard(null);
                                        setSelectedAmount(null);
                                    }}
                                    className="w-9 h-9 rounded-full bg-[#fff0f0] flex items-center justify-center text-[#F40009]"
                                >
                                    ✕
                                </button>

                            </div>

                            {/* IMAGE */}
                            <div className="rounded-2xl overflow-hidden mb-5">
                                <img
                                    src={selectedCard.image}
                                    alt={selectedCard.title}
                                    className="w-full h-[180px] object-cover"
                                />
                            </div>

                            {/* DESCRIPTION */}
                            <div
                                className="text-[13px] text-gray-600 leading-7"
                                dangerouslySetInnerHTML={{
                                    __html: selectedCard.description,
                                }}
                            />

                            {/* AMOUNT */}
                            <div className="mt-6">
                                <p className="text-[14px] font-semibold text-[#111111] mb-3">
                                    Select Amount
                                </p>

                                <div className="flex flex-wrap gap-2">

                                    {selectedCard.denominations?.map((item, idx) => {
                                        const amount = Number(item.fix_value);

                                        const isDisabled = availablePoints < amount;

                                        return (
                                            <button
                                                key={idx}
                                                disabled={isDisabled}
                                                onClick={() => {
                                                    if (!isDisabled) {
                                                        setSelectedAmount(amount);
                                                    }
                                                }}
                                                className={`px-4 py-2 rounded-xl border transition-all font-semibold
                                                    ${selectedAmount === amount
                                                        ? "bg-[#F40009] border-[#F40009] text-white"
                                                        : isDisabled
                                                            ? "bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed opacity-60"
                                                            : "bg-[#fff0f0] border-[#ffd6d6] text-[#F40009]"
                                                    }`}
                                            >
                                                ₹{amount}
                                            </button>
                                        );
                                    })}

                                </div>
                            </div>

                            {/* BUTTON */}
                            <button
                                onClick={handleRedeemGiftcard}
                                disabled={!selectedAmount || redeemLoading}
                                className="w-full mt-6 py-3 rounded-2xl text-[14px] font-semibold disabled:opacity-50"
                                style={{
                                    backgroundColor: "#F40009",
                                    color: "#fff",
                                }}
                            >
                                {redeemLoading
                                    ? "Processing..."
                                    : selectedAmount
                                        ? `Redeem ₹${selectedAmount}`
                                        : "Select Amount"}
                            </button>

                        </div>
                    </div>
                )}

            </div>
        </div>
    );
};